import React from 'react';
import { OrientationJobsList } from './OrientationJobsList';
import { PageLayout } from '@mp/components';
import { useProNavigate } from '@mp/contexts';

export const OrientationJobsListContainer = () => {
  const { navigate } = useProNavigate();
  return (
    <PageLayout handleBack={() => navigate('Today')}>
      <OrientationJobsList />
    </PageLayout>
  );
};
